/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMakeupRoom = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M5 2h14v5h3v2h-3v13H5zm12 5V4H7v16h10V9h-2.17a3.001 3.001 0 1 1 0-2zm-4 1a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm-.715 5.572a2.457 2.457 0 0 0-2.466 1.2l-1.185 2.053 4.32 2.494 1.186-2.052a2.455 2.455 0 0 0-.14-2.663l1.338-2.059-1.676-1.09zm-.075 2.048a.479.479 0 0 1 .197.647l-.044.077-.857-.494.045-.078a.479.479 0 0 1 .659-.152z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgMakeupRoom as MakeupRoom };
